module.exports = __webpack_public_path__ + "img/myOrder.3a557e1c.png";